import axios from "axios";

import {
  consumeAuthReturnParams,
  isAuthReturnSolicited,
  useAuthReturnParams,
} from "./auth-redirect";
import { config } from "./config";

type AuthTokens = {
  cognito_id_token: string;
  cognito_access_token: string;
  cognito_refresh_token: string;
  cognito_authorization: string;
};

// Consumes the session handed back by the auth app: it returns the user with
// `userId` + `authId` query params, exchanged here for Cognito tokens.
//
// The params are consumed on every outcome: leaving them pending would block
// `shouldRedirectToAuth` for the rest of the page-load and strand a failed
// exchange on the loader.
export async function getSessionFromAuthId(): Promise<AuthTokens | null> {
  const { userId, authId } = useAuthReturnParams.getState();
  if (!userId || !authId) {
    return null;
  }

  // A pair this tab did not ask for is dropped, never exchanged: the caller
  // falls back to its own session, or hands off to the auth app.
  if (!isAuthReturnSolicited() || !config.msApiEndpointApp) {
    consumeAuthReturnParams();
    return null;
  }

  try {
    const response = await axios<AuthTokens>({
      method: "GET",
      url: `${config.msApiEndpointApp}/webservices/rest/getauthid-auth`,
      params: {
        userId,
        authId,
      },
    });

    if (
      !response.data.cognito_access_token &&
      !response.data.cognito_authorization
    ) {
      return null;
    }

    return response.data;
  } finally {
    consumeAuthReturnParams();
  }
}
